import { Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@icc/ui';

@Component({
    selector: 'icc-complaint-v1-history',
    templateUrl: './complaint-v1-history.component.html',
    styleUrls: ['./complaint-v1-history.component.scss'],
})
export class ComplaintV1HistoryComponent {
    email = '';

    constructor(
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            complaintNumber: string;
        },
    ) {}

    close() {
        this.dialogRef.close();
    }

    sendEmail() {
        this.dialogRef.close({
            email: this.email
        });
    }
}
